import { render, staticRenderFns } from "./PatientSelect.vue?vue&type=template&id=3f375ae8&scoped=true&"
import script from "./PatientSelect.vue?vue&type=script&lang=js&"
export * from "./PatientSelect.vue?vue&type=script&lang=js&"
import style0 from "./PatientSelect.vue?vue&type=style&index=0&id=3f375ae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f375ae8",
  null
  
)

export default component.exports